<template>
  <transition :css="false" @enter="onEnter" @leave="onLeave">
    <div
      v-if="show"
      class="w-screen h-screen max-h-screen bg-black bg-opacity-95 fixed top-0 left-0 z-50 flex items-center justify-center"
      :class="$device.android || $device.ios ? 'fixed' : 'absolute'"
      @click="$emit('close')"
      :style="{ left: `${leftMargin}px`, pointerEvents: 'all' }"
    >
      <div class="container sm:px-16">
        <div class="w-full flex justify-end">
          <button class="text-white h-16" name="Close Video" @click="$emit('close')">
            <div class="w-8 h-4 relative flex items-center">
              <div
                style="height: 2px"
                :class="[
                  'w-full bg-white',
                  'transform transition duration-500 origin-center',
                  'translate-y-0 rotate-45',
                ]"
              ></div>
              <div
                style="height: 2px"
                :class="[
                  'w-full -ml-8 bg-white',
                  'transform transition duration-500 origin-center',
                  '-translate-y-0 -rotate-45',
                ]"
              ></div>
            </div>
          </button>
        </div>
        <div id="video" style="padding: 56.25% 0 0 0; position: relative" @click.stop>
          <iframe
            :src="`https://player.vimeo.com/video/${video}?${
              $device.android || $device.ios ? 'playsinline=0&loop=1' : 'autoplay=1&loop=1&autopause=0'
            }`"
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: all"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            ebkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
import { gsap } from "gsap";

export default {
  props: {
    show: { type: Boolean, default: false },
    leftMargin: { type: Number, default: 0 },
    video: { type: String, required: true },
  },
  mounted() {
    window.addEventListener("keydown", this.onEscape);
  },
  destroyed() {
    window.removeEventListener("keydown", this.onEscape);
  },
  methods: {
    onEnter(el, done) {
      document.body.classList.add("overflow-hidden");
      gsap.from(el, {
        opacity: 0,
        duration: 1,
        ease: "power4.out",
        onComplete: done,
      });
      gsap.from("#video", {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power4.out",
        delay: 0.2,
      });
    },
    onLeave(el, done) {
      document.body.classList.remove("overflow-hidden");
      gsap.to(el, {
        opacity: 0,
        duration: 1,
        delay: 0.2,
        ease: "power4.in",
        onComplete: done,
      });
      gsap.to("#video", {
        scale: 0.8,
        opacity: 0,
        ease: "power4.in",
        duration: 1,
      });
    },
    onEscape(ev) {
      if (ev.key === "Escape") {
        this.$emit("close");
      }
    },
  },
};
</script>

